<template>
  <div>
    <WebsiteHeader
      @show-login="showLoginForm"
      @get-company="getCompanyData"
    ></WebsiteHeader>

    <!-- main-slider -->
    <section id="hero">
      <v-row no-gutters>
        <v-img
          v-if="getUserCompany"
          :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
          :src="
            websiteBanner
              ? getApiUrl +
                '/images/website_banner/' +
                getUserCompany.emis +
                '/' +
                websiteBanner
              : ''
          "
        >
          <v-theme-provider dark>
            <v-container class="mt-14">
              <v-row justify="center" align="center" class="white--text">
                <v-col
                  class="white--text text-left"
                  :cols="$vuetify.breakpoint.smAndDown ? '12' : '7'"
                >
                  <span
                    v-if="!Template2"
                    :class="[
                      $vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2',
                    ]"
                    class="font-weight-light"
                    :style="{ color: getSecondaryColor }"
                    >WELCOME TO</span
                  >
                  <br />
                  <span
                    v-if="!Template2"
                    :class="[
                      $vuetify.breakpoint.smAndDown ? 'display-2' : 'display-3',
                    ]"
                    class="font-weight-black"
                    :style="{ color: getSecondaryColor }"
                    >{{ getAppTitle }}
                    <br />
                  </span>
                  <v-row class="mt-6">
                    <v-col :cols="6">
                      <v-btn
                        x-large
                        :style="{ 'background-color': 'red' }"
                        @click="goToFreeInvoices()"
                        ><v-icon>mdi-file-pdf</v-icon>Create Free
                        Invoices</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-col>

                <v-col
                  class="white--text text-right ml-14 mt-6"
                  :cols="$vuetify.breakpoint.smAndDown ? '12' : '4'"
                  v-if="showLogin"
                >
                  <v-card
                    outlined
                    :style="{ 'background-color': 'rgb(0,0,0,0.1)' }"
                    v-if="!getAuthenticated"
                    min-width="350"
                  >
                    <v-tabs
                      v-model="tab"
                      centered
                      icons-and-text
                      background-color="rgb(0,0,0,0.1)"
                    >
                      <v-tabs-slider></v-tabs-slider>

                      <v-tab href="#tab-1">
                        Login
                        <v-icon>mdi-login</v-icon>
                      </v-tab>

                      <v-tab href="#tab-2">
                        Register
                        <v-icon>mdi-account</v-icon>
                      </v-tab>
                    </v-tabs>

                    <v-tabs-items
                      v-model="tab"
                      :style="{ 'background-color': 'rgb(0,0,0,0.1)' }"
                    >
                      <v-tab-item v-for="i in 2" :key="i" :value="'tab-' + i">
                        <v-card
                          v-if="i == 1"
                          :style="{ 'background-color': 'rgb(0,0,0,0.1)' }"
                        >
                          <Login></Login>
                        </v-card>
                        <v-card
                          v-else-if="i == 2"
                          :style="{ 'background-color': 'rgb(0,0,0,0.1)' }"
                        >
                          <Register></Register>
                        </v-card>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-card>
                </v-col>

                <v-btn
                  class="align-self-end mx-2 mt-14"
                  fab
                  outlined
                  @click="$vuetify.goTo('#about-me')"
                  v-if="
                    !$vuetify.breakpoint.smAndDown &&
                    getUserCompany &&
                    !getUserCompany.emis == 'hands-of-hope-2022'
                  "
                >
                  <v-icon>mdi-chevron-double-down</v-icon>
                </v-btn>
              </v-row>
            </v-container>
          </v-theme-provider>
        </v-img>
      </v-row>
    </section>
    <!-- /main-slider -->
    <!--/bottom-3-grids-->
    <div class="w3l-3-grids mt-n16" id="grids-3">
      <div class="container-fluid mx-lg-0">
        <div class="row pt-sm-0 pt-5">
          <div
            class="col-lg-4 col-sm-6 mt-sm-0 m px-md-0 w3-gridhny-1 position-relative"
          >
            <div class="grids3-info">
              <span class="d-block zoom"
                ><img
                  width="97%"
                  height="80%"
                  src="https://myofficeonlineapi.bitsems.co.za/images/baronIT/ChurchMSDash.png"
                  alt=""
                  class="img-fluid news-image img"
              /></span>
              <div class="w3-grids3-info ml-4">
                <h6>
                  <a
                    href="https://phcsaonline.co.za"
                    class="category d-block"
                    target="_blank"
                    >ChurchMS</a
                  >
                </h6>
                <h4>
                  <a href="https://phcsaonline.co.za"
                    >Our Easy-To-Use Church Management <span>System</span></a
                  >
                </h4>
              </div>
            </div>
          </div>
          <div
            class="col-lg-4 col-sm-6 mt-sm-0 px-md-0 w3-gridhny-1 position-relative"
          >
            <div class="grids3-info">
              <span class="d-block zoom"
                ><img
                  width="97%"
                  height="80%"
                  src="https://myofficeonlineapi.bitsems.co.za/images/baronIT/create-invoice.png"
                  alt=""
                  class="img-fluid news-image img"
              /></span>
              <div class="w3-grids3-info second">
                <h6>
                  <a href="#" class="category d-block">Office Online</a>
                </h6>
                <h4>
                  <a href="#"
                    >All-in-One Toolbox for Creating Invoices<span
                      >& Quotes</span
                    ></a
                  >
                </h4>
              </div>
            </div>
          </div>
          <div
            class="col-lg-4 col-sm-6 mt-lg-0 px-md-0 w3-gridhny-1 position-relative"
          >
            <div class="grids3-info">
              <span class="d-block zoom"
                ><img
                  width="97%"
                  height="80%"
                  src="https://myofficeonlineapi.bitsems.co.za/images/baronIT/pos.png"
                  alt=""
                  class="img-fluid news-image img"
              /></span>
              <div class="w3-grids3-info">
                <h6>
                  <a href="#" class="category d-block">POS</a>
                </h6>
                <h4>
                  <a href="#"
                    >Our Very Intuitive Ponit Of Sale <span>System</span></a
                  >
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--//bottom-3-grids-->
    <!--/about-section-->
    <section class="w3l-index2" id="about">
      <div class="midd-w3 py-5">
        <div class="container py-md-5 py-3">
          <!--/row-1-->
          <div class="row">
            <div class="col-lg-6">
              <div class="w3shape position-relative">
                <img
                  src="https://myofficeonlineapi.bitsems.co.za/images/baronIT/pos-invoice.png"
                  alt=""
                  class="radius-image img-fluid"
                />
              </div>
            </div>
            <div class="col-lg-6 mt-lg-0 mt-md-5 mt-4 align-self ps-lg-5">
              <div class="title-content text-left">
                <h1 class="title-subhny mb-2">
                  <span>Your Office Online</span>
                </h1>
                <h3 class="title-w3l">
                  Run Your Business From Anywhere
                  <span class="span-bold">can be</span>
                </h3>
              </div>
              <p class="mt-md-4 mt-3">
                At Baron IT Solutions, we understand that paperwork can be one
                of the most tedious yet crucial parts of running a business, a
                church or a school. That’s why we have created solutions that’s
                simple, intuitive, and designed to save you time.
                <br />
                With our user-friendly interfaces and powerful features, you can
                spend less time on paperwork and more time doing what you love.
                No more fumbling with spreadsheets or manually tracking
                payments. No more worrying about late fees or missed
                opportunities. We’re here to make business administration,
                invoicing and quoting as easy and stress-free as possible. At
                the end of the day, it’s about helping you get paid faster, stay
                organized, and focus on growing your business.
              </p>
              <!-- <div class="w3l-two-buttons">
                <a
                  href="about.html"
                  class="btn btn-style btn-primary mt-lg-5 mt-4"
                  >Read More <span class="fas fa-angle-double-right ms-2"></span
                ></a>
                <a
                  href="#view"
                  class="btn btn-outline-primary btn-style mt-lg-5 mt-4 ms-2"
                >
                  Contact Us<span class="fas fa-angle-double-right ms-2"></span
                ></a>
              </div> -->
            </div>
          </div>
          <!--//row-1-->
          <!--/row-2-->
          <div class="row w3l-circles">
            <div class="col-lg-6 circles-left pe-lg-5 p-lg-0">
              <p class="mt-4">
                So whether you’re just starting out or have years of experience
                under your belt, we’re here to help you get the job done,
                without the hassle. Let us handle the admin, so you can focus on
                what matters most.
              </p>
              <!-- <div class="w3l-two-buttons">
                <a
                  href="about.html"
                  class="btn btn-style btn-primary mt-lg-5 mt-4"
                  >Read More <span class="fas fa-angle-double-right ms-2"></span
                ></a>
                <a
                  href="#view"
                  class="btn btn-outline-primary btn-style mt-lg-5 mt-4 ms-3"
                >
                  Services Info
                  <span class="fas fa-angle-double-right ms-2"></span
                ></a>
              </div> -->
            </div>
            <div
              class="col-lg-6 circles-right mt-lg-0 mt-5 align-self position-relative"
            >
              <div class="progress-circles text-lg-right">
                <div class="circle1">
                  <div
                    id="progress"
                    data-dimension="140"
                    data-text="95%"
                    data-fontsize="28"
                    data-percent="95"
                    data-fgcolor="#ff6700"
                    data-bgcolor="#eee"
                    data-width="15"
                    data-bordersize="10"
                    data-animationstep="2"
                  ></div>
                  <h4>Design</h4>
                </div>
                <div class="circle1">
                  <div
                    id="progress1"
                    data-dimension="140"
                    data-text="75%"
                    data-fontsize="28"
                    data-percent="75"
                    data-fgcolor="#ff6700"
                    data-bgcolor="#eee"
                    data-width="15"
                    data-bordersize="10"
                    data-animationstep="2"
                  ></div>
                  <h4>24/7 Support</h4>
                </div>
                <div class="circle1">
                  <div
                    id="progress2"
                    data-dimension="140"
                    data-text="100%"
                    data-fontsize="28"
                    data-percent="100"
                    data-fgcolor="#ff6700"
                    data-bgcolor="#eee"
                    data-width="15"
                    data-bordersize="10"
                    data-animationstep="2"
                  ></div>
                  <h4>
                    <v-btn
                      dark
                      color="blue"
                      @click="$router.push({ name: 'contact-us' })"
                      >Get Started</v-btn
                    >
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <!--//row-2-->
        </div>
      </div>
    </section>
    <!--//about-section-->

    <!--/about-section-->
    <section class="w3l-index2" id="about">
      <div class="midd-w3 py-5">
        <div class="container py-md-5 py-3">
          <!--/row-1-->
          <div class="row">
            <div class="col-lg-6">
              <div class="w3shape position-relative">
                <img
                  src="https://myofficeonlineapi.bitsems.co.za/images/baronIT/online-store.png"
                  alt=""
                  class="radius-image img-fluid"
                />
              </div>
            </div>
            <div class="col-lg-6 mt-lg-0 mt-md-5 mt-4 align-self ps-lg-5">
              <div class="title-content text-left">
                <h1 class="title-subhny mb-2">
                  <a href="https://store.baronitsolutions.co.za"
                    >Visit Our Online Store</a
                  >
                </h1>
                <h3 class="title-w3l">
                  Buy Good Quality Used And Refurbished
                  <span class="span-bold">Laptops</span>
                </h3>
              </div>
              <p class="mt-md-4 mt-3">
                Welcome to {{ getAppTitle }} Online Store, your trusted online
                destination for Good Quality Used And Refurbished laptops, as
                well as premium iPhones. <br />
                We offer a wide selection of top-quality devices, all backed by
                secure payments via PayFast for peace of mind. If you're located
                within the KwaZulu-Natal province, enjoy **free delivery**
                straight to your door, with a fast delivery time of **72
                hours**. Shop with confidence and experience convenience like
                never before!
              </p>
              <!-- <div class="w3l-two-buttons">
                <a
                  href="about.html"
                  class="btn btn-style btn-primary mt-lg-5 mt-4"
                  >Read More <span class="fas fa-angle-double-right ms-2"></span
                ></a>
                <a
                  href="#view"
                  class="btn btn-outline-primary btn-style mt-lg-5 mt-4 ms-2"
                >
                  Contact Us<span class="fas fa-angle-double-right ms-2"></span
                ></a>
              </div> -->
            </div>
          </div>
          <!--//row-1-->
          <!--/row-2-->
          <div class="row w3l-circles">
            <div class="col-lg-6 circles-left pe-lg-5 p-lg-0">
              <!-- <div class="w3l-two-buttons">
                <a
                  href="about.html"
                  class="btn btn-style btn-primary mt-lg-5 mt-4"
                  >Read More <span class="fas fa-angle-double-right ms-2"></span
                ></a>
                <a
                  href="#view"
                  class="btn btn-outline-primary btn-style mt-lg-5 mt-4 ms-3"
                >
                  Services Info
                  <span class="fas fa-angle-double-right ms-2"></span
                ></a>
              </div> -->
            </div>
            <div
              class="col-lg-6 circles-right mt-lg-0 mt-5 align-self position-relative"
            >
              <div class="progress-circles text-lg-right">
                <div class="circle1">
                  <div
                    id="progress"
                    data-dimension="140"
                    data-text="95%"
                    data-fontsize="28"
                    data-percent="95"
                    data-fgcolor="#ff6700"
                    data-bgcolor="#eee"
                    data-width="15"
                    data-bordersize="10"
                    data-animationstep="2"
                  ></div>
                  <h4></h4>
                </div>
                <div class="circle1">
                  <div
                    id="progress1"
                    data-dimension="140"
                    data-text="75%"
                    data-fontsize="28"
                    data-percent="75"
                    data-fgcolor="#ff6700"
                    data-bgcolor="#eee"
                    data-width="15"
                    data-bordersize="10"
                    data-animationstep="2"
                  ></div>
                  <h4>72 Hours Delivery</h4>
                </div>
                <div class="circle1">
                  <div
                    id="progress2"
                    data-dimension="140"
                    data-text="100%"
                    data-fontsize="28"
                    data-percent="100"
                    data-fgcolor="#ff6700"
                    data-bgcolor="#eee"
                    data-width="15"
                    data-bordersize="10"
                    data-animationstep="2"
                  ></div>
                  <h4>Free Delivery Within KZN</h4>
                </div>
              </div>
            </div>
          </div>
          <!--//row-2-->
        </div>
      </div>
    </section>
    <!--//about-section-->

    <!--/grids-->
    <section class="w3l-grids-3 home-page-gds py-5">
      <div class="container py-md-5 py-3">
        <div class="header-sec text-center pt-lg-5 mt-lg-5">
          <h3 class="title-w3l two mb-4 mt-lg-5">
            What Defines {{ getUserCompany.name }}
          </h3>
        </div>
        <div class="row bottom_grids text-left">
          <div class="col-lg-3 col-md-6 mt-5">
            <div class="grid-block text-center">
              <span class="d-block p-lg-4 p-3">
                <v-icon>mdi-eye</v-icon>
                <h4 class="my-3">Our Vision</h4>
                <p class="">
                  Empowering individuals, churches, schools and businesses with
                  innovative and intuitive software solutions that streamline
                  operations.
                </p>
              </span>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 mt-5">
            <div class="grid-block text-center">
              <span class="d-block p-lg-4 p-3">
                <v-icon>mdi-receipt</v-icon>
                <h4 class="my-3">Mission</h4>
                <p class="">
                  Our mission is to deliver cutting-edge software solutions that
                  enhance productivity, optimize workflows, and drive business
                  success.
                </p>
              </span>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 mt-5">
            <div class="grid-block text-center">
              <span class="d-block p-lg-4 p-3">
                <v-icon>mdi-database</v-icon>
                <h4 class="my-3">Quality Assurance</h4>

                <p class="">
                  We are dedicated to delivering the highest-quality software
                  solutions that our customers can rely on every day.
                </p>
              </span>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 mt-5">
            <div class="grid-block text-center">
              <span class="d-block p-lg-4 p-3">
                <v-icon>mdi-chat</v-icon>
                <h4 class="my-3">24/7 Support</h4>
                <p class="">
                  We are committed to providing exceptional service and ensuring
                  that your experience with our software is seamless and
                  hassle-free.
                </p>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--//grids-->

    <section class="w3l-project-main pb-md-0">
      <div class="container">
        <div class="w3l-project p-md-5 p-4 px-4">
          <div class="header-sec text-center">
            <h3 class="title-w3l two mb-4">
              Pricing For Invoices And Quotations System
            </h3>
          </div>
          <div class="row py-lg-4 px-lg-2 align-items-center">
            <v-row>
              <v-col
                v-for="(plan, i) in plans"
                :key="i"
                :cols="isMobile ? 12 : 4"
              >
                <v-card class="" color="grey lighten-5" flat>
                  <PricingTables
                    :plan="plan"
                    v-if="companyData"
                  ></PricingTables>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
    </section>

    <section class="w3l-courses" id="blog">
      <div class="blog py-5" id="classes">
        <div class="container py-lg-5">
          <div class="header-secw3 text-center">
            <h6 class="title-subhny mb-2"><span>Classifieds</span></h6>
            <h3 class="title-w3l mb-3">
              Recent Promotions
              <span class="span-bold">Running</span>
            </h3>
          </div>

          <div class="row align-items-center">
            <div class="col-lg-4 col-md-6 item mt-lg-5 mt-4">
              <div class="card">
                <div class="card-header p-0 position-relative">
                  <a href="blog-single.html" class="zoom d-block">
                    <img
                      class="card-img-bottom d-block"
                      src="https://myofficeonlineapi.bitsems.co.za/images/baronIT/churchms-ad.jpeg"
                      alt="Card image cap"
                    />
                  </a>
                </div>
                <!-- <div class="card-body course-details">
                  <div class="course-meta mb-3">
                    <div class="meta-item course-lesson">
                      <a href="#"
                        ><span class="fas fa-user"></span>
                        <span class="meta-value">By Ambady </span></a
                      >
                    </div>

                    <div class="meta-item course-students">
                      <span class="fas fa-calendar-week"></span>
                      <span class="meta-value"> 12.10.2021 </span>
                    </div>
                  </div>
                  <a href="blog-single.html" class="course-desc"
                    >Preparing for your success trusted source in services
                  </a>
                  <p class="mt-3">
                    Lorem ipsum dolor sit, amet consectetur elit.Pellen tesque
                    libero ut justo, ultrices in ligula.
                  </p>
                  <div class="blog-bottom-info">
                    <a
                      href="blog-single.html"
                      class="btn btn-primary btn-style mt-4"
                      >Read More
                      <span class="fas fa-angle-double-right ms-2"></span
                    ></a>
                  </div>
                </div> -->
              </div>
            </div>

            <div class="col-lg-4 col-md-6 item mt-lg-5 mt-4">
              <div class="card">
                <div class="card-header p-0 position-relative">
                  <a href="blog-single.html" class="zoom d-block">
                    <img
                      class="card-img-bottom d-block"
                      src="https://myofficeonlineapi.bitsems.co.za/images/baronIT/get-a-website.png"
                      alt="Card image cap"
                    />
                  </a>
                </div>
                <!-- <div class="card-body course-details">
                  <div class="course-meta mb-3">
                    <div class="meta-item course-lesson">
                      <a href="#"
                        ><span class="fas fa-user"></span>
                        <span class="meta-value">By Ambady </span></a
                      >
                    </div>

                    <div class="meta-item course-students">
                      <span class="fas fa-calendar-week"></span>
                      <span class="meta-value"> 12.10.2021 </span>
                    </div>
                  </div>
                  <a href="blog-single.html" class="course-desc"
                    >We bring solutions to manage your finance
                  </a>
                  <p class="mt-3">
                    Lorem ipsum dolor sit, amet consectetur elit.Pellen tesque
                    libero ut justo, ultrices in ligula.
                  </p>
                  <div class="blog-bottom-info">
                    <a
                      href="blog-single.html"
                      class="btn btn-primary btn-style mt-4"
                      >Read More
                      <span class="fas fa-angle-double-right ms-2"></span
                    ></a>
                  </div>
                </div> -->
              </div>
            </div>

            <div class="col-lg-4 col-md-6 item mt-lg-5 mt-4">
              <div class="card">
                <div class="card-header p-0 position-relative">
                  <a href="blog-single.html" class="zoom d-block">
                    <img
                      class="card-img-bottom d-block"
                      src="https://myofficeonlineapi.bitsems.co.za/images/baronIT/learn-it.jpeg"
                      alt="Card image cap"
                    />
                  </a>
                </div>
                <!-- <div class="card-body course-details">
                  <div class="course-meta mb-3">
                    <div class="meta-item course-lesson">
                      <a href="#"
                        ><span class="fas fa-user"></span>
                        <span class="meta-value">By Ambady </span></a
                      >
                    </div>

                    <div class="meta-item course-students">
                      <span class="fas fa-calendar-week"></span>
                      <span class="meta-value"> 12.10.2021 </span>
                    </div>
                  </div>
                  <a href="blog-single.html" class="course-desc"
                    >Preparing for your success trusted source in services
                  </a>

                  <p class="mt-3">
                    Lorem ipsum dolor sit, amet consectetur elit.Pellen tesque
                    libero ut justo, ultrices in ligula.
                  </p>
                  <div class="blog-bottom-info">
                    <a
                      href="blog-single.html"
                      class="btn btn-primary btn-style mt-4"
                      >Read More
                      <span class="fas fa-angle-double-right ms-2"></span
                    ></a>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--/tabs-faqs-->
    <section class="w3l-products w3l-faq-block py-5" id="projects">
      <div class="container py-lg-5 py-md-4 py-2">
        <div class="row">
          <div class="col-lg-6 mx-auto pe-lg-5">
            <h1 class="title-subhny mb-2"><span>Core Solutions</span></h1>
            <h3 class="title-w3l mb-lg-5 mb-4">
              Custom Domain, Website and Emails:
            </h3>
            <!--Horizontal Tab-->
            <div id="parentHorizontalTab">
              <!-- <ul class="resp-tabs-list hor_1 mb-2">
                <li>What we do</li>
                <li>Our Mission</li>
                <li>Social impact</li>
                <div class="clear"></div>
              </ul> -->
              <div class="resp-tabs-container hor_1">
                <div class="products-content">
                  <h3 class="title-w3l mb-lg-5 mb-4">
                    Online Giving And Donations:
                  </h3>
                  <br />
                  <!-- <p>
                    Dolor ipsum non velit, culpa! Vivamus a et ut justo, init in
                    dolor et ipsum non velit adipiscing elit.
                  </p> -->
                  <!-- <ul class="w3l-right-book mt-4">
                    <li>
                      <span class="fa fa-check" aria-hidden="true"></span
                      >Leading private equity firms
                    </li>
                  </ul> -->
                </div>
                <div class="products-content">
                  <h3 class="title-w3l mb-lg-5 mb-4">
                    Streamline Communication:
                  </h3>
                  <br />
                </div>
                <div class="products-content">
                  <h3 class="title-w3l mb-lg-5 mb-4">
                    Manage Membership and Attendance:
                  </h3>
                  <br />
                </div>

                <div class="products-content">
                  <h3 class="title-w3l mb-lg-5 mb-4">Event Management:</h3>
                  <br />
                </div>

                <div class="products-content">
                  <h3 class="title-w3l mb-lg-5 mb-4">Volunteer Management:</h3>
                  <br />
                </div>

                <div class="products-content">
                  <h3 class="title-w3l mb-lg-5 mb-4">Reports and Analytics:</h3>
                  <br />
                </div>
                <div class="products-content">
                  <h3 class="title-w3l mb-lg-5 mb-4">
                    Mobile App Integration:
                  </h3>
                  <br />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 mt-lg-0 mt-sm-5 mt-4">
            <div class="accordion">
              <div class="accordion-item">
                <button id="accordion-button-1" aria-expanded="true">
                  <span class="accordion-title">Already Have A Website?</span
                  ><span class="icon" aria-hidden="true"></span>
                </button>
                <div class="accordion-content">
                  <p>
                    If you already have a website, we can easily integrate our
                    system on your website or Get a personalised and branded
                    domain name and Website, for example nameofyourchurch.co.za
                    and emails, for example bishop@nameofyourchurch.co.za
                  </p>
                </div>
              </div>
              <div class="accordion-item">
                <button id="accordion-button-2" aria-expanded="false">
                  <span class="accordion-title"
                    >Want to receive payments online?</span
                  ><span class="icon" aria-hidden="true"></span>
                </button>
                <div class="accordion-content">
                  <p>
                    Offer a secure, easy-to-use online giving platform, making
                    it easier for members to tithe and donate anytime, anywhere
                    and on any device.
                  </p>
                </div>
              </div>
              <div class="accordion-item">
                <button id="accordion-button-3" aria-expanded="false">
                  <span class="accordion-title"
                    >Need to communicate in large volumes?</span
                  ><span class="icon" aria-hidden="true"></span>
                </button>
                <div class="accordion-content">
                  <p>
                    Send group emails, Bulk SMS, or push notifications to
                    clients, members, volunteers, and leaders.
                  </p>
                </div>
              </div>
              <div class="accordion-item">
                <button id="accordion-button-4" aria-expanded="false">
                  <span class="accordion-title"
                    >Tired of Member files and paperwork?</span
                  ><span class="icon" aria-hidden="true"></span>
                </button>
                <div class="accordion-content">
                  <p>
                    Track and manage member data, attendance records, and
                    engagement in one central location.
                  </p>
                </div>
              </div>
              <div class="accordion-item">
                <button id="accordion-button-4" aria-expanded="false">
                  <span class="accordion-title"
                    >Worried about data and analytics?</span
                  ><span class="icon" aria-hidden="true"></span>
                </button>
                <div class="accordion-content">
                  <p>
                    Access real-time data and reports to better understand
                    giving trends, attendance patterns, and other key metrics.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--//tabs-faqs-->

    <!--/w3l-project-->
    <section class="w3l-project-main pb-md-0">
      <div class="container">
        <div class="w3l-project p-md-5 p-4 px-4">
          <div class="row py-lg-4 px-lg-2 align-items-center">
            <div class="col-lg-8 w3l-project-right">
              <div class="bottom-info">
                <div class="header-section pr-lg-5">
                  <h3 class="title-w3l two">
                    Request Free Consultation or Video Demo Via ZOOM<br />and
                    <span class="span-bold">Lets Get Started!</span>
                  </h3>
                </div>
              </div>
            </div>
            <div class="col-lg-4 w3l-project-left mt-lg-0 mt-4">
              <a href="tel:0762439441" class="btn btn-secondary btn-style">
                Request Now <v-icon color="green" dark>mdi-whatsapp</v-icon></a
              >
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--//w3l-project-->
    <div style="margin: 8px auto; display: block; text-align: center"></div>

    <!-- /features-->
    <!-- <section class="w3l-featureshny py-5" id="features">
      <div class="container py-md-4 py-2">
        <div class="row align-items-center">
          <div class="col-lg-8 pe-lg-5 mb-lg-0 mb-5">
            <div class="w3l-header-sec text-left mb-md-5 mb-4">
              <h6 class="title-subhny mb-2"><span>Creative Strategy</span></h6>
              <h5 class="">
                Company that believes in the power of
                <span class="span-bold">creative strategy</span>
              </h5>
              <p class="mt-3 pr-lg-5">
                Lorem ipsum viverra feugiat. Pellen tesque libero ut justo,
                ultrices in ligula. Semper at tempufddfel. Lorem ipsum dolor sit
                amet elit. Non quae, fugiat nihil ad. Lorem ipsum dolor sit
                amet.Vivamus a et ut justo, init in dolor.
              </p>
              <a
                href="services.html"
                class="btn btn-primary btn-style mt-lg-5 mt-4"
              >
                Read More <span class="fas fa-angle-double-right ms-2"></span
              ></a>
            </div>
          </div>
          <div class="col-lg-4 mb-lg-0 mb-md-5 mb-4">
            <div class="whybox-wrap mb-4">
              <div class="whybox-wrap-grid">
                <div class="icon">
                  <span class="fas fa-lightbulb"></span>
                </div>
                <div class="info">
                  <h4><a href="#url">Collect Ideas</a></h4>
                  <p class="mt-3">
                    Lorem ipsum dolor sit amet consectetur ipsum amet elit.
                  </p>
                </div>
              </div>
            </div>
            <div class="whybox-wrap mb-4">
              <div class="whybox-wrap-grid">
                <div class="icon">
                  <span class="fas fa-database"></span>
                </div>
                <div class="info">
                  <h4><a href="#url">Data Analysis</a></h4>
                  <p class="mt-3">
                    Lorem ipsum dolor sit amet consectetur ipsum amet elit.
                  </p>
                </div>
              </div>
            </div>
            <div class="whybox-wrap">
              <div class="whybox-wrap-grid">
                <div class="icon">
                  <span class="fas fa-chart-area"></span>
                </div>
                <div class="info">
                  <h4><a href="#url">Finalize Product</a></h4>
                  <p class="mt-3">
                    Lorem ipsum dolor sit amet consectetur ipsum amet elit.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <!-- //features-->
    <div style="margin: 8px auto; display: block; text-align: center"></div>
    <!-- testimonials -->
    <!-- <section class="w3l-clients pb-5" id="clients">
      
      <div class="cusrtomer-layout py-5">
        <div class="container py-lg-4 py-md-3">
          <div class="heading text-center mx-auto">
            <h6 class="title-subhny mb-2"><span>Testimonials</span></h6>
            <h3 class="title-w3l mb-5">
              Happy Clients
              <span class="span-bold">& Feedbacks</span>
            </h3>
          </div>
         
          <div class="testimonial-width">
            <div id="owl-demo1" class="owl-two owl-carousel owl-theme">
              <div class="item">
                <div class="testimonial-content">
                  <div class="testimonial">
                    <blockquote>
                      <q
                        ><i class="fas fa-quote-left"></i> Lorem ipsum dolor sit
                        amet consectetur adipisicing elit. Velit beatae
                        laudantium voluptate rem ullam dolore nisi voluptatibus
                        esse quasi, doloribus tempora. Dolores molestias
                        adipisci dolor sit amet!.</q
                      >
                    </blockquote>
                    <div class="testi-des">
                      <div class="test-img">
                        <img
                          src="https://myofficeonlineapi.bitsems.co.za/images/bitsems/ChurchMSDash.png"
                          class="img-fluid"
                          alt="client-img"
                        />
                      </div>
                      <div class="peopl align-self">
                        <h3>John wilson</h3>
                        <p class="indentity">Example City</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="testimonial-content">
                  <div class="testimonial">
                    <blockquote>
                      <q
                        ><i class="fas fa-quote-left"></i> Lorem ipsum dolor sit
                        amet consectetur adipisicing elit. Velit beatae
                        laudantium voluptate rem ullam dolore nisi voluptatibus
                        esse quasi, doloribus tempora. Dolores molestias
                        adipisci dolor sit amet!.</q
                      >
                    </blockquote>
                    <div class="testi-des">
                      <div class="test-img">
                        <img
                          src="https://myofficeonlineapi.bitsems.co.za/images/bitsems/ChurchMSDash.png"
                          class="img-fluid"
                          alt="client-img"
                        />
                      </div>
                      <div class="peopl align-self">
                        <h3>Julia sakura</h3>
                        <p class="indentity">Example City</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="testimonial-content">
                  <div class="testimonial">
                    <blockquote>
                      <q
                        ><i class="fas fa-quote-left"></i> Lorem ipsum dolor sit
                        amet consectetur adipisicing elit. Velit beatae
                        laudantium voluptate rem ullam dolore nisi voluptatibus
                        esse quasi, doloribus tempora. Dolores molestias
                        adipisci dolor sit amet!.</q
                      >
                    </blockquote>
                    <div class="testi-des">
                      <div class="test-img">
                        <img
                          src="assets/images/team3.jpg"
                          class="img-fluid"
                          alt="client-img"
                        />
                      </div>
                      <div class="peopl align-self">
                        <h3>Roy Linderson</h3>
                        <p class="indentity">Example City</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="testimonial-content">
                  <div class="testimonial">
                    <blockquote>
                      <q
                        ><i class="fas fa-quote-left"></i> Lorem ipsum dolor sit
                        amet consectetur adipisicing elit. Velit beatae
                        laudantium voluptate rem ullam dolore nisi voluptatibus
                        esse quasi, doloribus tempora. Dolores molestias
                        adipisci dolor sit amet!.</q
                      >
                    </blockquote>
                    <div class="testi-des">
                      <div class="test-img">
                        <img
                          src="assets/images/team4.jpg"
                          class="img-fluid"
                          alt="client-img"
                        />
                      </div>
                      <div class="peopl align-self">
                        <h3>Mike Thyson</h3>
                        <p class="indentity">Example City</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="testimonial-content">
                  <div class="testimonial">
                    <blockquote>
                      <q
                        ><i class="fas fa-quote-left"></i> Lorem ipsum dolor sit
                        amet consectetur adipisicing elit. Velit beatae
                        laudantium voluptate rem ullam dolore nisi voluptatibus
                        esse quasi, doloribus tempora. Dolores molestias
                        adipisci dolor sit amet!.</q
                      >
                    </blockquote>
                    <div class="testi-des">
                      <div class="test-img">
                        <img
                          src="https://myofficeonlineapi.bitsems.co.za/images/bitsems/ChurchMSDash.png"
                          class="img-fluid"
                          alt="client-img"
                        />
                      </div>
                      <div class="peopl align-self">
                        <h3>Laura gill</h3>
                        <p class="indentity">Example City</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="testimonial-content">
                  <div class="testimonial">
                    <blockquote>
                      <q
                        ><i class="fas fa-quote-left"></i> Lorem ipsum dolor sit
                        amet consectetur adipisicing elit. Velit beatae
                        laudantium voluptate rem ullam dolore nisi voluptatibus
                        esse quasi, doloribus tempora. Dolores molestias
                        adipisci dolor sit amet!.</q
                      >
                    </blockquote>
                    <div class="testi-des">
                      <div class="test-img">
                        <img
                          src="assets/images/team3.jpg"
                          class="img-fluid"
                          alt="client-img"
                        />
                      </div>
                      <div class="peopl align-self">
                        <h3>Smith Johnson</h3>
                        <p class="indentity">Example City</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="testimonial-content">
                  <div class="testimonial">
                    <blockquote>
                      <q
                        ><i class="fas fa-quote-left"></i> Lorem ipsum dolor sit
                        amet consectetur adipisicing elit. Velit beatae
                        laudantium voluptate rem ullam dolore nisi voluptatibus
                        esse quasi, doloribus tempora. Dolores molestias
                        adipisci dolor sit amet!.</q
                      >
                    </blockquote>
                    <div class="testi-des">
                      <div class="test-img">
                        <img
                          src="assets/images/team4.jpg"
                          class="img-fluid"
                          alt="client-img"
                        />
                      </div>
                      <div class="peopl align-self">
                        <h3>Roy Linderson</h3>
                        <p class="indentity">Example City</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="item">
                <div class="testimonial-content">
                  <div class="testimonial">
                    <blockquote>
                      <q
                        ><i class="fas fa-quote-left"></i> Lorem ipsum dolor sit
                        amet consectetur adipisicing elit. Velit beatae
                        laudantium voluptate rem ullam dolore nisi voluptatibus
                        esse quasi, doloribus tempora. Dolores molestias
                        adipisci dolor sit amet!.</q
                      >
                    </blockquote>
                    <div class="testi-des">
                      <div class="test-img">
                        <img
                          src="assets/images/team2.jpg"
                          class="img-fluid"
                          alt="client-img"
                        />
                      </div>
                      <div class="peopl align-self">
                        <h3>Mike Thyson</h3>
                        <p class="indentity">Example City</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>
      
    </section> -->

    <!-- //testimonials -->
    <!--/w3l-footer-29-main-->
    <footer class="w3l-footer-29-main">
      <div class="footer-29 py-5">
        <div class="container py-lg-4">
          <div class="row align-items-center mb-3">
            <h2 class="sign-left col-lg-7">
              Join our community by using our services and grow your business.
            </h2>
            <div class="footerw3-btn col-lg-5 ps-lg-5">
              <a
                href="#"
                class="btn btn-secondary btn-style"
                style="background-color: red"
                @click="goToFreeInvoices()"
              >
                Try it For Free
                <span class="fas fa-angle-double-right ms-2"></span
              ></a>
            </div>
          </div>

          <div class="row footer-top-29 mt-md-5 mt-4">
            <div class="col-lg-4 col-md-6 footer-list-29 footer-1 pe-lg-5">
              <h6 class="footer-title-29">About</h6>
              <div class="footer-listw3-grids">
                <p class="pe-lg-4">
                  Our Dedicated Support Staff is Always Available 24/7 to Help
                  With Any Issues You May Have
                </p>
                <div class="w3pt-call-box mt-4">
                  <div class="w3pt-call-info">
                    <h5>Contact Us</h5>

                    <h5>
                      <a href="tel:+27 76 243 9441"
                        ><i class="fas fa-phone-alt me-1"></i> +27 76 243
                        9441</a
                      >
                    </h5>
                    <!-- <h5>
                      <a href="tel:0762439441"
                        ><v-icon>mdi-phone</v-icon>0762439441
                        <a
                          href="/cdn-cgi/l/email-protection#61121411110e1315210c00080d4f020e0c"
                          class="mail"
                        >
                          <span
                            class="__cf_email__"
                            data-cfemail="6615131616091412260b070f0a4805090b"
                            >[email&#160;protected]</span
                          ></a
                        >
                      </a>
                    </h5> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="col-lg-2 col-md-6 footer-list-29 footer-3 mt-lg-0 mt-5">
              <h6 class="footer-title-29">Links</h6>
              <div class="footer-listw3-grids">
                <ul class="footer-listw3">
                  <li><a href="#us">About Us</a></li>
                  <li><a href="#team">Our Team</a></li>
                  <li><a href="#pro">Projects</a></li>
                  <li><a href="#career">Careers</a></li>
                  <li><a href="#terms">Terms of Use</a></li>
                  <li><a href="#tips">Privacy Policy</a></li>
                </ul>
              </div>
            </div> -->
            <div class="col-lg-2 col-md-6 footer-list-29 footer-3 mt-lg-0 mt-5">
              <h6 class="footer-title-29">Services</h6>
              <div class="footer-listw3-grids">
                <ul class="footer-listw3">
                  <li><a href="#">Web App Development</a></li>
                  <li><a href="#">Web Hosting</a></li>
                  <li><a href="#">Email Hosting</a></li>
                  <li><a href="#">Mobile App Development</a></li>
                  <li><a href="#">Search Engine Optimisation</a></li>
                  <li><a href="#">Digital Marketing</a></li>
                </ul>
              </div>
            </div>

            <div
              class="col-lg-4 col-md-6 footer-list-29 footer-4 mt-lg-0 mt-5 ps-lg-5"
            >
              <h6 class="footer-title-29">Keep Connected</h6>
              <p>Get Updates By Subscribing To Our Weekly Newsletter</p>

              <form action="#" class="subscribe" method="post">
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email Address"
                  required=""
                />
                <button><span class="fas fa-paper-plane"></span></button>
              </form>
              <div class="main-social-footer-29 mt-4">
                <a href="#facebook" class="facebook"
                  ><span class="fab fa-facebook-f"></span
                ></a>
                <a href="#twitter" class="twitter"
                  ><span class="fab fa-twitter"></span
                ></a>
                <a href="#instagram" class="instagram"
                  ><span class="fab fa-instagram"></span
                ></a>

                <a href="#linkd" class="linkd"
                  ><span class="fab fa-linkedin-in"></span
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button @click="topFunction()" id="movetop" title="Go to top">
        <span class="fa fa-angle-up"></span>
      </button>
    </footer>

    <WebsiteFooter></WebsiteFooter>
  </div>
</template>

<script>
import imagesJs from "@/plugins/images";
import baronjs from "@/plugins/baron";
import helpersJs from "@/plugins/helpers";
import WebsiteHeader from "@/components/SchoolWebsite/WebsiteHeader.vue";
import WebsiteFooter from "@/components/SchoolWebsite/WebsiteFooter.vue";
import PricingTables from "@/components/SchoolWebsite/PricingTables.vue";
import Login from "@/components/Login.vue";
import Register from "@/components/Register.vue";
import $ from "jquery";

export default {
  components: {
    WebsiteHeader,
    WebsiteFooter,
    Login,
    Register,
    PricingTables,
  },
  computed: {
    getAuthenticated() {
      return this.$store.getters.getAuthenticated;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    getAppTitle() {
      return baronjs.appName();
    },
  },
  updated() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
  },
  async mounted() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
    const domain = window.location.hostname;
    this.websiteBanner = await imagesJs.getWebsiteBanner(domain);

    $(document).ready(function () {
      //Horizontal Tab
      $("#parentHorizontalTab").easyResponsiveTabs({
        type: "default", //Types: default, vertical, accordion
        width: "auto", //auto or any width like 600px
        fit: true, // 100% fit in a container
        tabidentify: "hor_1", // The tab groups identifier
        activate: function () {
          // Callback function if tab is switched
          const $tab = $(this);
          const $info = $("#nested-tabInfo");
          const $name = $("span", $info);
          $name.text($tab.text());
          $info.show();
        },
      });
      $(".owl-one").owlCarousel({
        loop: true,
        margin: 0,
        nav: false,
        responsiveClass: true,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplaySpeed: 1000,
        autoplayHoverPause: false,
        responsive: {
          0: {
            items: 1,
          },
          480: {
            items: 1,
          },
          667: {
            items: 1,
          },
          1000: {
            items: 1,
          },
        },
      });
      $(".popup-with-zoom-anim").magnificPopup({
        type: "inline",

        fixedContentPos: false,
        fixedBgPos: true,

        overflowY: "auto",

        closeBtnInside: true,
        preloader: false,

        midClick: true,
        removalDelay: 300,
        mainClass: "my-mfp-zoom-in",
      });

      $(".popup-with-move-anim").magnificPopup({
        type: "inline",

        fixedContentPos: false,
        fixedBgPos: true,

        overflowY: "auto",

        closeBtnInside: true,
        preloader: false,

        midClick: true,
        removalDelay: 300,
        mainClass: "my-mfp-slide-bottom",
      });

      $("#owl-demo1").owlCarousel({
        loop: true,
        margin: 200,
        nav: false,
        responsiveClass: true,
        responsive: {
          0: {
            items: 1,
            nav: false,
          },
          736: {
            items: 1,
            nav: false,
          },
          1000: {
            items: 2,
            nav: false,
            margin: 30,
            loop: false,
          },
        },
      });
    });
  },
  data: () => ({
    companyData: null,
    websiteBanner: null,
    Template2: false,
    tab: null,
    showLogin: true,
    //trial: {
    //   title: "Free Plan",
    //   price: "0 / year",
    //   items: [
    //     "Unlimited Invoices",
    //     "Unlimited Quotations",
    //     "Clients Management",
    //     "Bulk Emails & Marketing",
    //     "One (1) User",
    //   ]
    // },
    plans: [
      {
        title: "Standard Plan",
        price: 1999,
        items: [
          "Unlimited Invoices",
          "Unlimited Quotations",
          "Incomes & Expenses Statements",
          "Budget Manager",
          "Own Website & Branding",
          "Clients Management",
          "Professional Email Address",
          "Bulk SMS & Emails Marketing",
          "Ten 10 Users",
        ],
      },
      {
        title: "Premium Plan",
        price: 2999,
        items: [
          "All Standard Features",
          "Client & Staff Bookings",
          "HR & Payroll",
          "Report Builder",
          "Unlimited Users",
          "Image Gallery",
          "Point Of Sale",
          "Online Store",
        ],
      },
      {
        title: "Legal Plan",
        price: 4499,
        items: [
          "All Premium Features",
          "Online FIle Manager",
          "Case Management",
          "Legal Bill Of cost",
          "Medical / Professional Billing",
        ],
      },
    ],
  }),
  methods: {
    goToFreeInvoices() {
      this.$router.push("/free-invoices-and-quotes");
    },
    async getWebsiteBanner(domain) {
      return await imagesJs.getWebsiteBanner(domain);
    },
    async getCompanyData(companyData) {
      this.companyData = companyData;
      const currencyConversionRate =
        await helpersJs.getCurrencyConversionRateFromFrankfurterApi(
          this.companyData.currency,
          this.getCurrency
        );

      const plans = [];

      this.plans.forEach((plan) => {
        plan.price = helpersJs.convertCurrencyFrankfurterApi(
          parseFloat(plan.price),
          currencyConversionRate
        );
        plans.push(plan);
      });
      this.plans = plans;
    },
    formatMoney(amount) {
      return helpersJs.formatMoney(amount);
    },

    showLoginForm() {
      this.showLogin = !this.showLogin;
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
}

.img {
  max-height: 470px;
  max-height: 500px;
  width: 98%;
  object-fit: cover;
}

#w3lDemoBar.w3l-demo-bar {
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  padding: 40px 5px;
  padding-top: 70px;
  margin-bottom: 70px;
  background: #0d1326;
  border-top-left-radius: 9px;
  border-bottom-left-radius: 9px;
}

#w3lDemoBar.w3l-demo-bar a {
  display: block;
  color: #e6ebff;
  text-decoration: none;
  line-height: 24px;
  opacity: 0.6;
  margin-bottom: 20px;
  text-align: center;
}

#w3lDemoBar.w3l-demo-bar span.w3l-icon {
  display: block;
}

#w3lDemoBar.w3l-demo-bar a:hover {
  opacity: 1;
}

#w3lDemoBar.w3l-demo-bar .w3l-icon svg {
  color: #e6ebff;
}
#w3lDemoBar.w3l-demo-bar .responsive-icons {
  margin-top: 30px;
  border-top: 1px solid #41414d;
  padding-top: 40px;
}
#w3lDemoBar.w3l-demo-bar .demo-btns {
  border-top: 1px solid #41414d;
  padding-top: 30px;
}
#w3lDemoBar.w3l-demo-bar .responsive-icons a span.fa {
  font-size: 26px;
}
#w3lDemoBar.w3l-demo-bar .no-margin-bottom {
  margin-bottom: 0;
}
.toggle-right-sidebar span {
  background: #0d1326;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #e6ebff;
  border-radius: 50px;
  font-size: 26px;
  cursor: pointer;
  opacity: 0.5;
}
.pull-right {
  float: right;
  position: fixed;
  right: 0px;
  top: 70px;
  width: 90px;
  z-index: 99999;
  text-align: center;
}
/* ============================================================
RIGHT SIDEBAR SECTION
============================================================ */

#right-sidebar {
  width: 90px;
  position: fixed;
  height: 100%;
  z-index: 1000;
  right: 0px;
  top: 0;
  margin-top: 60px;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  overflow-y: auto;
}

/* ============================================================
RIGHT SIDEBAR TOGGLE SECTION
============================================================ */

.hide-right-bar-notifications {
  margin-right: -300px !important;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

@media (max-width: 992px) {
  #w3lDemoBar.w3l-demo-bar a.desktop-mode {
    display: none;
  }
}
@media (max-width: 767px) {
  #w3lDemoBar.w3l-demo-bar a.tablet-mode {
    display: none;
  }
}
@media (max-width: 568px) {
  #w3lDemoBar.w3l-demo-bar a.mobile-mode {
    display: none;
  }
  #w3lDemoBar.w3l-demo-bar .responsive-icons {
    margin-top: 0px;
    border-top: none;
    padding-top: 0px;
  }
  #right-sidebar,
  .pull-right {
    width: 90px;
  }
  #w3lDemoBar.w3l-demo-bar .no-margin-bottom-mobile {
    margin-bottom: 0;
  }
}
</style>
